import { useTranslation } from 'react-i18next';
import { Stack, Text } from '@mantine/core';
import DocRow from '@/components/app/deals/steps/forwarding/DocRow';
import { collectDocsByDay } from '@/lib/forwardingView';
import { fmtFwdDate } from '@/lib/forwarding';
import type { BargainDocument } from '@/types/deals';

interface DealDocsByDayProps {
  readonly documents: readonly BargainDocument[] | undefined;
}

// «Документы по дням»: РТС, реестры, справки-расчёты, расписки и отчёты экспедитора, сгруппированные по
// дню (по убыванию даты). УПД здесь нет — он в блоке «Подпись УПД». ТТН/ТРН — в карточках ТС.
export default function DealDocsByDay({ documents }: DealDocsByDayProps) {
  const { t } = useTranslation();
  const days = collectDocsByDay(documents);

  return (
    <Stack gap="md">
      <Text fz="sm" fw={600} c="gray.8">
        {t('app.deals.forwarding.docsByDayTitle')}
      </Text>
      {days.length === 0 ? (
        <Text fz="sm" c="gray.6">
          {t('app.deals.forwarding.docsByDayEmpty')}
        </Text>
      ) : (
        days.map((day, i) => (
          <Stack key={day.date ?? `nodate-${i}`} gap="xs">
            <Text fz="xs" fw={600} c="gray.7">
              {fmtFwdDate(day.date) ?? t('app.deals.forwarding.docsNoDate')}
            </Text>
            <Stack gap="xs" pl="sm">
              {day.docs.map((doc, di) => (
                <DocRow key={doc.id ?? `${i}-${di}`} doc={doc} />
              ))}
            </Stack>
          </Stack>
        ))
      )}
    </Stack>
  );
}
